<div class="content-text-hide">
    <span class="content-text"><!--class="hide-text"-->
        <ng-container *ngIf="!isShow; else showText">
            ............
        </ng-container>
        <ng-template #showText>
            <ng-content>
            </ng-content>
        </ng-template>
    </span>
    <p-button *ngIf="!hideButton" (click)="taggle()" [rounded]="true" [text]="true" severity="secondary ">
        <ng-template pTemplate="icon">
            <div class="flex">
                <split-icon name="eye-off"></split-icon>
            </div>
        </ng-template>
    </p-button>
</div>
